import React, { useEffect, useMemo, useState } from "react";

import { Line, Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import moment from "moment";
import ChartState from "./_shared/ChartState";
import { ACCENT, GRID_COLOR } from "./_shared/chartTheme";

const GemstoneReportsClicksComp = ({ data, loading, onChartTypeChange }) => {
  const { t } = useTranslation();
  const [chartType, setChartType] = useState("line");
  // Reports the current Donut/Bar (Line/Bar) view up to the page so its
  // Download PDF renders the same view - same as the Diamond cards.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { onChartTypeChange?.(chartType); }, [chartType]);

  // Sort chronologically ascending — the API returns them in reverse.
  const sortedList = useMemo(
    () => [...(data || [])].sort((a, b) => moment(a.Date) - moment(b.Date)),
    [data]
  );
  const gemstoneClicksLabels = sortedList.map((item) => item.Date);
  const GemstoneClicksYAxisList = sortedList.map((item) => item.CNT);

  const chartJsData = {
    labels: gemstoneClicksLabels,
    datasets: [
      {
        label: t("Clicks"),
        data: GemstoneClicksYAxisList,
        backgroundColor:
          chartType === "bar" ? ACCENT : "rgba(59, 91, 219, .15)",
        borderColor: ACCENT,
        borderWidth: 2,
        fill: chartType === "line",
        tension: 0.35,
        pointRadius: chartType === "line" ? 2 : 0,
        borderRadius: 3,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: { legend: { display: false } },
    scales: {
      x: { grid: { display: false } },
      y: { grid: { color: GRID_COLOR }, beginAtZero: true },
    },
  };

  return (
    <React.Fragment>
      <div className="edr-panel mt-4">
        <div className="edr-panel-head">
          <label>
            <b> {t("Gemstone Clicks")} </b>
          </label>
          <div className="edr-seg">
            <button
              className={chartType === "line" ? "edr-on" : ""}
              onClick={() => setChartType("line")}
            >
              {t("Line")}
            </button>
            <button
              className={chartType === "bar" ? "edr-on" : ""}
              onClick={() => setChartType("bar")}
            >
              {t("Bar")}
            </button>
          </div>
        </div>
        <div className="chart__section">
          {!loading && gemstoneClicksLabels.length > 0 ? (
            <div className="edr-chartwrap edr-tall">
              {chartType === "line" ? (
                <Line data={chartJsData} options={options} />
              ) : (
                <Bar data={chartJsData} options={options} />
              )}
            </div>
          ) : (
            <ChartState loading={loading} />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default GemstoneReportsClicksComp;
